import { ButtonData } from "./components/wordpress/types_and_parser/extra_types.mod"
import { PublicSiteCustomRoutes, TokenMemo } from "./components/public_site/custom_pages/types.mod"
import { mkWidget, Widget } from "widgets-for-react"
import { PublicSiteState } from "./components/public_site.main.mod"
import { AppState } from "./components/cms/state/types.gen"
import { headerBlockData } from "./components/public_site/blocks/custom_blocks/types.mod"

export type Option<T> = { kind: 'none', } | { kind: 'some', value: T }

export function Option<T>(value: T): Option<T> {
  if (!value) return { kind: 'none' }

  return {
    kind: 'some',
    value: value,
  }
}

export const get_wordpress_lang = (): string => window.wp.language ? window.wp.language : 'nl'

/** Creates a widget from a cont -> JSX.Element */
export const fromJSX = <s,>(w: (cont: (_: s) => void) => JSX.Element): Widget<s> =>
  mkWidget({ run: w })

export function toRelativeUrl(url: string): string {
  return url.replace(`${window.location.protocol}//${window.location.host}`, '')
}

export function urlIsExternal(url: string): boolean {
  return url.startsWith('http') && !url.startsWith(`${window.location.protocol}://${window.location.host}`)
}

export function createButtonData(text: string, url: string): ButtonData {
  return { text: text, url: url }
}

export type ViewPortSize = 'mobile' | 'tablet' | 'desktop'

export type LoadState<T> = {
  kind: 'loading'
} | {
  kind: 'error'
  errors: {
    [key: string]: string
  }
} | {
  kind: 'loaded'
  data: Option<T>
}


export function resizeImage(url: string, width: number, height: number): string {
  // Implement resize
  return url;
}

export function upperCaseFirst(text: string): string {
  return text ? text.substring(0, 1).toUpperCase() + text.substring(1) : ''
}

const escapeChars = { lt: '<', gt: '>', quot: '"', apos: "'", amp: '&' };

export function unescapeHTML(str) {//modified from underscore.string and string.js
  return str.replace(/\&([^;]+);/g, function (entity, entityCode) {
    var match;

    if (entityCode in escapeChars) {
      return escapeChars[entityCode];
    } else if (match = entityCode.match(/^#x([\da-fA-F]+)$/)) {
      return String.fromCharCode(parseInt(match[1], 16));
    } else if (match = entityCode.match(/^#(\d+)$/)) {
      return String.fromCharCode(~~match[1]);
    } else {
      return entity;
    }
  });
}

export function safeGet(tokenMemo: TokenMemo, key1: string, key2: string) {
  if (!tokenMemo.has(key1))
    return ''
  if (!tokenMemo.get(key1).has(key2))
    return ''
  return tokenMemo.get(key1).get(key2)
}

export type AvailableLanguages = 'nl' | 'en' | 'de'


export const removeLangFromSlug = (slug: string, lang: string): string => {
  if (slug) {
    var pathArray = slug.split('/');
    if (!pathArray[0]) pathArray.shift();
    if (pathArray[0] == lang && (lang == 'en' || lang == "nl" || lang == "de")) {
      lang = pathArray[0]
      pathArray.shift();
    }
    slug = `/${pathArray.join('/')}`
  }
  return slug
}



const GroupArray_AUX = <a>(res: a[][], c: number) => (arr: a[], size: number): a[][] => {
  if (c < arr.length) {
    return GroupArray_AUX(res.concat([arr.slice(c, c + size)]), c += size)(arr, size)
  }
  return res
}

/**
 * Devides an array into an array of arrays given a certain size. 
 * I.e. In: ([1,2,3,4], 2) => OUT: [[1,2], [3,4]]
 * @param arr 
 * @param size 
 */
export const GroupArray = <a>(arr: a[], size: number): a[][] => GroupArray_AUX<a>([], 0)(arr, size)


export const CloseVideoOrHeader = (s: AppState<PublicSiteState, PublicSiteCustomRoutes>): AppState<PublicSiteState, PublicSiteCustomRoutes> => {
  let headerBlock = s.state.Fc150YearsMainPage.state.page.blocks.find(b => b.kind == 'headerBlock') as headerBlockData
  let blockKey = s.state.Fc150YearsMainPage.state.page.blocks.findKey(b => b.kind == 'headerBlock')

  if (headerBlock == undefined && blockKey != undefined) return s

  let newMenuState: 'closed' | 'open' = headerBlock.value.fst.video_playing ? 'closed' : 'open'

  headerBlock = ({
    ...headerBlock,
    value: {
      ...headerBlock.value,
      fst: {
        ...headerBlock.value.fst,
        video_playing: false
      }
    }
  })


  return ({
    ...s,
    state: {
      ...s.state,
      header: {
        ...s.state.header,
        menu: newMenuState
      },
      Fc150YearsMainPage: {
        ...s.state.Fc150YearsMainPage,
        state: {
          ...s.state.Fc150YearsMainPage.state,
          page: {
            ...s.state.Fc150YearsMainPage.state.page,
            blocks: s.state.Fc150YearsMainPage.state.page.blocks.set(blockKey, headerBlock)
          },
        }
      }
    },
  })
}

export const closeSearchAndMenu = s1 => (
  {
    ...s1,
    state: {
      ...s1.state,
      header: {
        ...s1.state.header,
        menu: 'closed',
        hoveredItem: null,
        showSearchBar: false
      }
    }
  }
)


/**
 * Returns a random number between min (inclusive) and max (exclusive)
 */
export function getRandomArbitrary(min, max) {
  return Math.ceil(Math.random() * (max - min) + min);
}


export function setCookie(cname: string, cvalue: string, exdays: number) {
  var d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  var expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
}

export function getCookie(cname: string) {
  var name = cname + '='
  var ca = document.cookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) == ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}